import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  fetchCategories,
  fetchCategoryById,
  createCategoryApi,
  updateCategoryApi,
  deleteCategoryApi,
} from "../services/categoriesService";

const CATEGORIES_QUERY_KEY = ["categories"];

export const useCategories = (params = {}) =>
  useQuery({
    queryKey: [...CATEGORIES_QUERY_KEY, params],
    queryFn: () => fetchCategories(params),
  });

export const useCategory = (id, options = {}) =>
  useQuery({
    queryKey: [...CATEGORIES_QUERY_KEY, id],
    queryFn: () => fetchCategoryById(id),
    enabled: !!id,
    ...options,
  });

export const useCreateCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createCategoryApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATEGORIES_QUERY_KEY });
      toast.success("Catégorie bien ajoutée", { autoClose: 3000 });
    },
    onError: () => {
      toast.error("Catégorie non ajoutée", { autoClose: 3000 });
    },
  });
};

export const useUpdateCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => updateCategoryApi(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATEGORIES_QUERY_KEY });
      toast.success("Catégorie bien modifiée", { autoClose: 3000 });
    },
    onError: () => {
      toast.error("Catégorie non modifiée", { autoClose: 3000 });
    },
  });
};

export const useDeleteCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteCategoryApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATEGORIES_QUERY_KEY });
    },
  });
};
